import {parseDocument} from 'htmlparser2';
import {type DataNode, isTag, isText} from 'domhandler';
import {littleText} from './littleText';

export function transformHtmlPostToText(content: string): string {
  const dom = parseDocument(content);
  let text = '';
  for (const line of dom.children) {
    if (isTag(line) && line.name === 'p') {
      for (const item of line.children) {
        if (isTag(item) && item.name === 'a' && item.attribs.class === 'ql-mention') {
          const mentionUrn = item.attribs['data-mention-urn'];
          const originalText = item.attribs['data-original-text'];
          const isValidUrn =
            mentionUrn !== undefined &&
            (mentionUrn.startsWith('urn:li:person:') || mentionUrn.startsWith('urn:li:organization:'));
          text +=
            isValidUrn && originalText !== undefined
              ? `@[${originalText.replace(/[|{}@[\]()<>#\\*_~]/g, '\\$&')}](${mentionUrn.replace(/[|{}@[\]()<>#\\*_~]/g, '\\$&')})`
              : originalText !== undefined
                ? littleText(`@${originalText}`)
                : (item.firstChild as DataNode).data;
        } else if (isTag(item) && item.name === 'strong') {
          text += (item.firstChild as DataNode).data;
        } else if (isText(item)) {
          text += littleText(item.data);
        }
      }
      text += '\n';
    } else {
      text += (line as DataNode).data + '\n';
    }
  }
  text = text.replace(/\n$/, '');
  return text;
}
